export enum ROLE_NAME_ENUM {
    ADMIN = 'ADMIN',
    RESELLER_ADMIN = 'RESELLER_ADMIN',
    CUSTOMER_ADMIN = 'CUSTOMER_ADMIN',
    USER = 'USER',
    DATASET_VIEWER = 'DATASET_VIEWER',
    SKIPLIST_MANAGER = 'SKIPLIST_MANAGER',
}
